/**
 * Get Currency
 *
 * Return correct currency based on amount and currencyCode
 * if multiple currencies, add locale. currently hard-coded (en-US)
 *
 * @param {String} currencyCode
 * @param {String} amount
 * @return {String} amount with correct currency
 */
export var getCurrency = function getCurrency(currencyCode, amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode
  }).format(amount);
};

/**
 * Get Compare At Percent
 *
 * Returns the Percent Off of the sale item
 *
 * @param {Object} variant
 * @return {Number} Percent off
 */
export var getCompareAtPercentOff = function getCompareAtPercentOff(variant) {
  return Math.floor(100 - variant.priceV2.amount * 100 / variant.compareAtPriceV2.amount);
};

/**
 * Get Selected Variant Prices
 *
 * Returns the selected variants price object which includes
 *    price: string
 *    isSaleVariant: bool
 *    compareAtPrice: string
 *    compareAtPercentOff: Number
 *
 * @param {Object} variant
 * @return {Object} Variant's Price Object
 */
export var getSelectedVariantPrices = function getSelectedVariantPrices(variant) {
  var priceObj = {};

  priceObj.price = getCurrency(variant.priceV2.currencyCode, variant.priceV2.amount);

  priceObj.isSaleVariant = variant.compareAtPriceV2 && parseFloat(variant.compareAtPriceV2.amount) > parseFloat(variant.priceV2.amount);

  priceObj.compareAtPrice = variant.compareAtPriceV2 && getCurrency(variant.compareAtPriceV2.currencyCode, variant.compareAtPriceV2.amount);

  priceObj.compareAtPercentOff = variant.compareAtPriceV2 && getCompareAtPercentOff(variant);

  return priceObj;
};

/**
 * Renders price w/o decimal if none
 * but renders decimal/cents if available
 */

export var showPriceWithDecimalIfAvailable = function showPriceWithDecimalIfAvailable(price) {
  var priceFloat = parseFloat(price.replace('$', ''));
  return priceFloat % 1 !== 0 ? '$' + priceFloat.toFixed(2) : '$' + parseInt(priceFloat);
};